import { render } from "./MolecularSearch.vue?vue&type=template&id=3f67ba9c&scoped=true"
import script from "./MolecularSearch.vue?vue&type=script&lang=js"
export * from "./MolecularSearch.vue?vue&type=script&lang=js"

import "./MolecularSearch.vue?vue&type=style&index=0&id=3f67ba9c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f67ba9c"]])

export default __exports__